<mat-progress-bar mode="indeterminate" aria-label="Loading"></mat-progress-bar>